var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripRouteIc1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1104_3400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 1.33325C13.4431 1.33325 14.6666 2.54315 14.6666 4.01098C14.6666 5.50219 13.4231 6.54867 12.2746 7.26025C12.1909 7.30812 12.0963 7.33325 11.9999 7.33325C11.9036 7.33325 11.809 7.30812 11.7253 7.26025C10.5789 6.54172 9.33325 5.50735 9.33325 4.01098C9.33325 2.54315 10.5568 1.33325 11.9999 1.33325Z",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4H12.0048",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 14.6667C4.43782 14.6667 5.33325 13.7713 5.33325 12.6667C5.33325 11.5622 4.43782 10.6667 3.33325 10.6667C2.22868 10.6667 1.33325 11.5622 1.33325 12.6667C1.33325 13.7713 2.22868 14.6667 3.33325 14.6667Z",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 4.66675H6.33333C5.04467 4.66675 4 5.56218 4 6.66675C4 7.77135 5.04467 8.66675 6.33333 8.66675H8.33333C9.622 8.66675 10.6667 9.56215 10.6667 10.6667C10.6667 11.7713 9.622 12.6667 8.33333 12.6667H7.33333",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1104_3400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripRouteIc1);
export default __webpack_public_path__ + "static/media/trip_route_ic1.89ac1901a47f05fe3dea3ab0de2430de.svg";
export { ForwardRef as ReactComponent };